// Added by Sejune Oh on 2019-03-11
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Theme } from '@material-ui/core'
import { Property } from 'csstype'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = (theme: Theme) => ({
    MgmtListWrapper: {
        paddingTop: `${theme.spacing() * 2}px`,
        paddingBottom: `${theme.spacing() * 2}px`,
    },
    ListBtnWrapper: {
        display: 'flex' as Property.Display,
        justifyContent: 'space-between' as Property.JustifyContent,
    },
})

export default styles
